export default __webpack_public_path__ + "4-46fd076232290847794a587c06e93063.jpg";